// Two-stage navigator gate (design Decision 3 of XHYD-1950).
//
// `<NavigatorBridge>` stores the v7 `useNavigate()` callback synchronously
// in its render body via `setNavigator`, then flips activation on in a
// commit-phase effect via `activateNavigator`. Between those two phases,
// any caller of `navigate(...)` (e.g. a class component's constructor that
// dispatches on cold load) is queued and flushed during activation.
// Outside the bridge's lifecycle, `navigate(...)` throws — silent drops
// are the failure mode this module exists to prevent.
//
// On unmount, ALL state is cleared so post-unmount calls surface loudly
// (the throw branch) and pre-remount queued items cannot replay against
// a freshly-mounted bridge's callback.

let _navigate = null;
let _activated = false;
let _queue = [];

export const setNavigator = (callback) => {
    _navigate = callback;
};

export const activateNavigator = () => {
    _activated = true;
    const pending = _queue;
    _queue = [];
    for (const args of pending) {
        _navigate(...args);
    }
};

export const deactivateNavigator = () => {
    _activated = false;
    _navigate = null;
    _queue = [];
};

export const navigate = (...args) => {
    if (!_navigate) {
        throw new Error('navigator: navigate(...) called before <NavigatorBridge /> rendered');
    }

    if (!_activated) {
        _queue.push(args);
        return;
    }

    _navigate(...args);
};

export const __resetNavigatorForTests = () => {
    _navigate = null;
    _activated = false;
    _queue = [];
};
